import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
// 导入vuex实例
// import store from '@/store'
// import request from '@/utils/request'

import Layout from '@/views/Layout'
import Home from '@/views/home'
import Product from '@/views/product'
import Xdc from '@/views/xdc'
import Report from '@/views/report'
import Monitor from '@/views/monitor'
import CecIndex from '@/views/cecIndex'
import Auth from '@/views/auth'
import Contact from '@/views/contact'
import Financial from '@/views/financial'

Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    name: 'layout',
    component: Layout,
    children: [
      {
        path: '',
        name: 'home',
        component: Home
      },
      {
        path: '/',
        name: 'home',
        component: Home
      }, {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
        path: 'product',
        name: 'product',
        component: Product
      },
      {
        path: 'xdc',
        name: 'xdc',
        component: Xdc
      },
      {
        path: 'report',
        name: 'report',
        component: Report
      },
      {
        path: 'monitor',
        name: 'monitor',
        component: Monitor
      },
      {
        path: 'cecIndex',
        name: 'cecIndex',
        component: CecIndex
      },
      {
        path: 'auth',
        name: 'auth',
        component: Auth
      },
      {
        path: 'contact',
        name: 'contact',
        component: Contact
      },
      {
        path: 'financial',
        name: 'financial',
        component: Financial
      },
    ]
  }
]
// 创建路由实例
const router = new VueRouter({
  routes
})

export default router
